import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FletesService {
  departamentosList: any;
  constructor() {
    this.departamentos();
   }

  departamentos(){
    this.departamentosList = [
      {
        nombre: 'cundinamarca',
        ciudades: ['bogota', 'soacha']
      },
      {
        nombre: 'antioquia',
        ciudades: ['medellin', 'itagui','envigado', 'apartado', 'turbo', 'rionegro', 'caucasia', 'bello']
      },
      {
        nombre: 'santander',
        ciudades: ['bucaramanga', 'floridablanca','giron', 'barrancabermeja', 'piedecuesta']
      },
      {
        nombre: 'nariño',
        ciudades: ['pasto', 'tumaco']
      },
      {
        nombre: 'guajira',
        ciudades: ['riohacha', 'maicao']
      },
      {
        nombre: 'atlantico',
        ciudades: ['barranquilla', 'soledad']
      },
      {
        nombre: 'casanare',
        ciudades: ['yopal']
      },
      {
        nombre: 'tolima',
        ciudades: ['ibague']
      },
      {
        nombre: 'meta',
        ciudades: ['villavicencio']
      },
      {
        nombre: 'magdalena',
        ciudades: ['santa marta']
      },
      {
        nombre: 'cesar',
        ciudades: ['valledupar']
      },
      {
        nombre: 'bolivar',
        ciudades: ['cartagena']
      },
      {
        nombre: 'norte de santander',
        ciudades: ['cucuta']
      },
      {
        nombre: 'cordoba',
        ciudades: ['monteria']
      },
      {
        nombre: 'huila',
        ciudades: ['neiva']
      },
      {
        nombre: 'cauca',
        ciudades: ['popayan']
      },
      {
        nombre: 'sucre',
        ciudades: ['sincelejo']
      },
      {
        nombre: 'boyaca',
        ciudades: ['tunja']
      },
      {
        nombre: 'caqueta',
        ciudades: ['florencia']
      },
      {
        nombre: 'choco',
        ciudades: ['quibdo']
      },
      {
        nombre: 'valle del cauca',
        ciudades: ['cali', 'buenaventura', 'palmira', 'tulua', 'alcala', 'ulloa', 'caicedonia', 'sevilla', 'cartago', 'ansermanuevo', 'zaragoza', 'obando', 'la victoria', 'zarzal', 'la paila', 'roldanillo', 'la union', 'toro']
      },
      {
        nombre: 'caldas',
        ciudades: ['manizales' , 'chinchina', 'villamaria', 'viterbo', 'anserma', 'riosucio', 'supia']
      },
      {
        nombre: 'quindio',
        ciudades: ['filandia' , 'circasia', 'salento', 'armenia', 'calarca', 'montenegro', 'quimbaya', 'la tebaida', 'pueblo tapao', 'barcelona']
      },
      {
        nombre: 'risaralda',
        ciudades: ['la virginia' , 'belen de umbria', 'guatica', 'quinchia', 'marsella', 'santa rosa de cabal', 'pereira', 'dosquebradas', 'pereira-extra']
      },

    ];

  }
}
